'use client'

import { Add } from '../../../icons'
import { cn } from '../../../utils/cn'
import { formatNumber } from '../../../utils/formatNumber'

export interface FeeBreakdownProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Shortage amount in yen
   */
  value: number

  /**
   * Small payment handling fee in yen
   */
  transactionFee: number
}

/**
 * Price block that splits a shortage purchase into the shortage itself plus the
 * small payment handling fee, followed by the combined total.
 *
 * Shared by the 都度払い plan card and the 不足ポイントのみ購入 point card,
 * which render the same breakdown.
 */
export const FeeBreakdown = ({
  className,
  value,
  transactionFee,
}: FeeBreakdownProps) => (
  <div className={cn('flex w-full max-w-[280px] flex-col gap-2', className)}>
    <div className="flex items-center justify-center gap-1 border-b border-solid border-gray-02 pb-1">
      <span className="w-[120px] text-center text-blue-01 typography-subhead1">
        {formatNumber(value)}円
      </span>

      <Add className="size-4 shrink-0 text-gray-01" />

      <span className="flex w-[120px] flex-col items-center">
        <span className="text-black typography-caption1">
          <span className="text-red-01">少額決済手数料</span> ※
        </span>
        <span className="text-red-01 typography-subhead1">
          {formatNumber(transactionFee)}円 (税込)
        </span>
      </span>
    </div>

    <div className="flex items-center justify-center gap-1 text-blue-01">
      <span className="typography-body2">合計</span>
      <span className="typography-subhead1">
        {formatNumber(value + transactionFee)}円
      </span>
      <span className="typography-body2">/回</span>
    </div>
  </div>
)
